import React from "react";
import { Card, Accordion, Container, Row, Col, Badge } from "react-bootstrap";
import { IconContext } from "react-icons";
import { IconInfo } from "./IconInfo";
import "./cardStatus.css";
import { useIntl } from "react-intl";
import { SemiDonutChart } from "./SemiDonutChart";

export const CardStatusProntoSoccorso = ({ hospitalState, nedocsValue }) => {

  const intl = useIntl();
  const { formatMessage } = intl;

  const summaryStatusAccordion = {
    badgeContent: [
      {
        backgroundColorBadge: "#eb3852",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceRosso' }),
        total: hospitalState.status.summaryStatus.totalRed,
        waiting: hospitalState.status.summaryStatus.waitingRed,
        colorIcon: "#eb3852",
        tipoUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.tipoUrgenzaRosso' }),
        messUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.messUrgenzaRosso' })
      },
      {
        backgroundColorBadge: "rgb(246, 182, 56)",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceArancione' }),
        total: hospitalState.status.summaryStatus.totalOrange,
        waiting: hospitalState.status.summaryStatus.waitingOrange,
        colorIcon: "rgb(246, 182, 56)",
        tipoUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.tipoUrgenzaArancione' }),
        messUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.messUrgenzaArancione' })
      },
      {
        backgroundColorBadge: "#00b4f8",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceBlu' }),
        total: hospitalState.status.summaryStatus.totalBlue,
        waiting: hospitalState.status.summaryStatus.waitingBlue,
        colorIcon: "#00b4f8",
        tipoUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.tipoUrgenzaBlu' }),
        messUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.messUrgenzaBlu' })
      },
      {
        backgroundColorBadge: "#56c965",
        textColorBadge: "white",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceVerde' }),
        total: hospitalState.status.summaryStatus.totalGreen,
        waiting: hospitalState.status.summaryStatus.waitingGreen,
        colorIcon: "#56c965",
        tipoUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.tipoUrgenzaVerde' }),
        messUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.messUrgenzaVerde' })
      },
      {
        backgroundColorBadge: "none",
        textColorBadge: "black",
        coloreCodice: intl.formatMessage({ id: 'monitoraggioPazientePage.codiceBianco' }),
        total: hospitalState.status.summaryStatus.totalWhite,
        waiting: hospitalState.status.summaryStatus.waitingWhite,
        colorIcon: "grey",
        tipoUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.tipoUrgenzaBianco' }),
        messUrgenza: intl.formatMessage({ id: 'monitoraggioPazientePage.messUrgenzaBianco' })
      },
    ]
  };

  return (
    <Container>
      <Row className=" justify-content-center">
        <Col lg={8}>
          <Card
            className="shadow border-0 text-dark border-card"
            style={{ padding: "1rem", marginTop: "5rem" }}
          >
            <Row
              style={{
                alignItems: "center",
                marginBottom: "1em"
              }}
            >
              <Col xs={8} md={8} lg={9}>
                <Col lg={12}>
                  <div style={{ fontWeight: "bold", fontSize: "90%" }}>
                    {formatMessage({ id: 'homePage.statusProntoSoccorso' })}
                  </div>
                </Col>
                <Col lg={12}>
                  <Card.Text style={{ fontSize: "60%", color: "#727272" }}>
                    {formatMessage({ id: 'cardStatusProntoSoccorso.indiceAffollamento' })}
                  </Card.Text>
                </Col>
              </Col>

              <Col xs={4} md={4} lg={3}>
                <div >
                  <SemiDonutChart percentage={nedocsValue > 0 ? nedocsValue : 0} percentageColor={"#000"} />
                </div>
              </Col>
            </Row>
            {summaryStatusAccordion.badgeContent.map((element, index) => (
              <Card
                key={index.toString()}
                className="text-dark border-card py-3 py-md-2 mb-3 mb-md-2 bg-white"
                style={{
                  borderRadius: 8,
                }}
              >
                <Accordion>
                  <Row
                    className=" align-items-center"
                    style={{ marginLeft: 0, marginRight: 0 }}
                  >
                    <Col
                      lg={{ span: 1, order: 0 }}
                      md={{ span: 1, order: 0 }}
                      xs={{ span: 2, order: 0 }}
                    >
                      <Card
                        className=" align-items-center"
                        style={{
                          minWidth: "min-content",
                          borderRadius: 8,
                        }}
                      >
                        <Badge
                          style={{
                            backgroundColor: element.backgroundColorBadge,
                            fontSize: "105%",
                            color: element.textColorBadge,
                            minWidth: "min-content",
                          }}
                          className="w-100"
                        >
                          {element.total}
                        </Badge>
                      </Card>
                    </Col>
                    <Col
                      lg={{ span: 5, order: 1 }}
                      md={{ span: 5, order: 1 }}
                      xs={{ span: 8, order: 1 }}
                      className=" align-items-center"
                    >
                      <div style={{ fontSize: "55%", marginLeft: "3%" }}>
                        <b>{formatMessage({ id: 'cardStatusProntoSoccorso.codUrgenza' })} {element.coloreCodice}</b>
                      </div>
                    </Col>
                    <Col
                      lg={{ span: 5, order: 2 }}
                      md={{ span: 5, order: 2 }}
                      xs={{ span: 12, order: 3 }}
                      className="align-items-center mt-2 mt-md-0"
                    >
                      <div style={{ backgroundColor: "#F4F4F4", justifyContent: "flex-start", color: "#727272", display: "flex", borderRadius: 8, padding: "1% 0" }}>
                        <span style={{ marginLeft: "3%", fontWeight: "bold", fontSize: "75%" }}>
                          {element.waiting}
                        </span>
                        <span style={{ fontSize: "50%", marginLeft: "3%", alignContent: "center", display: "grid", fontWeight: "500" }}>
                          {formatMessage({ id: 'homePage.inAttesa' })}
                        </span>
                        <span style={{ marginLeft: "8%", fontWeight: "bold", fontSize: "75%" }}>
                          {element.total - element.waiting}
                        </span>
                        <span style={{ fontSize: "50%", marginLeft: "3%", alignContent: "center", display: "grid", fontWeight: "500" }}>
                          {formatMessage({ id: 'cardStatusProntoSoccorso.statusInTrattamento' })}
                        </span>
                      </div>
                    </Col>
                    <Col
                      lg={{ span: 1, order: 3 }}
                      md={{ span: 1, order: 3 }}
                      xs={{ span: 2, order: 2 }}
                      className="text-right"
                    >
                      <IconContext.Provider
                        value={{
                          color: "grey",
                          className: "global-class-name"
                        }}
                      >
                        <IconInfo
                          fontSize="1em"
                          marginTop="-0.25em"
                          eventKey={index}
                        />
                      </IconContext.Provider>
                    </Col>
                  </Row>
                  <Accordion.Collapse eventKey={index}>
                    <Card.Body className="p-0 pt-3 mx-3 mb-3 mt-2 border-top">
                      <div style={{ fontSize: "50%", fontWeight: "bold", color: "#727272" }}>{element.tipoUrgenza}</div>
                      <div style={{ fontSize: "50%", color: "#727272" }}>{element.messUrgenza}</div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Accordion>
              </Card>
            ))}
          </Card>
        </Col>
      </Row>
      <Row style={{ marginBottom: "8rem" }} />
    </Container>
  );
};
